// lib
import { useState } from 'react'
import PropTypes from 'prop-types'

// components
import TransitionPanel from '@aytm/app/stats/components/transition-panel/TransitionPanel'

// styles
import style from '@aytm/app/stats/page/sidebar/target/styles/TargetPanel.module.scss'
import { pressable } from '@aytm/app/stats/components/lib/pressable'

const RowCollapsable = ({ label = '', values = '' }) => {
  const safeValues = values ?? '' // null slips past the `= ''` default (fires only for undefined) and crashes on .length

  const isLong =
    (Array.isArray(safeValues) && 10 < safeValues.length) || (!Array.isArray(safeValues) && 200 < safeValues.length)

  const [collapsed, setCollapsed] = useState(isLong)

  return (
    <div className={style.row}>
      <span className={`${style.column} ${style['column-label']}`}>{label}:</span>
      {isLong ? (
        <>
          <TransitionPanel
            className={`${style.column} ${style['column-values']}`}
            in={!collapsed}
            dangerouslySetInnerHTML={{ __html: Array.isArray(safeValues) ? safeValues.join('<br/>') : safeValues }}
          />
          <span
            className={style['column-toggle']}
            aria-label={collapsed ? 'Show more' : 'Show less'}
            aria-expanded={!collapsed}
            {...pressable(() => setCollapsed(!collapsed))}
          >
            {collapsed ? '+' : '-'}
          </span>
        </>
      ) : (
        <div
          className={`${style.column} ${style['column-values']}`}
          dangerouslySetInnerHTML={{ __html: Array.isArray(safeValues) ? safeValues.join('<br/>') : safeValues }}
        ></div>
      )}
    </div>
  )
}

RowCollapsable.propTypes = {
  label: PropTypes.string,
  values: PropTypes.any
}

RowCollapsable.displayName = 'RowCollapsable'

export default RowCollapsable
